// src/sot/layouts/SettingsScreenShell.jsx
import React from "react";

/**
 * SettingsScreenShell
 * - SSOT rails for Settings / Profile / Security screens
 * - 720px on mobile, 1008px on md+
 * - ✅ NO top padding: TopBar owns head air globally
 */
export default function SettingsScreenShell({ children, className = "" }) {
  return (
    <div
      className={[
        "afrimed-rail afrimed-rail--comfortable pt-4 pb-24",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}